import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { Trade } from './pages/allocation/models/trade';
import { DataService } from './shared/services/data.service';
import { AuthService } from '@auth0/auth0-angular';
import { TokenService } from './shared/services/token.service';
import { UserService } from './shared/services/user.service';
import { distinctUntilChanged, filter, take, tap } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})

export class AppComponent implements OnInit, OnDestroy {

  private currentTrade: Trade;
  private tradeSubscription: Subscription;
  private riaIdSubscription: Subscription;


  constructor(private data: DataService,
    public auth: AuthService,
    private tokenService: TokenService,
    private userService: UserService) { }

  ngOnInit() {
    this.tradeSubscription = this.data.currentTrade$.subscribe(trade => this.currentTrade = trade);
    //this.riaIdSubscription = this.data.currentRiaId$.subscribe(riaId => this.riaId = riaId);
    this.initTokenData();    
  }

  ngOnDestroy() {
    this.tradeSubscription.unsubscribe();
    this.riaIdSubscription.unsubscribe();
  }

  initTokenData(): void {
    // Don't clear token immediately - let Auth0 handle the state
    this.auth.isAuthenticated$.pipe(
      distinctUntilChanged(), 
      filter(isAuthenticated => isAuthenticated),
      take(1)
    ).subscribe(isAuthenticated => {
      if(isAuthenticated){
        this.auth.getAccessTokenSilently().subscribe(token=> {
          if(token){
            this.tokenService.addToken(token);
            this.setRiaId(this.tokenService.getFdcnId());
          }   
        });
      }
    });
  }
  
  setRiaId(fdcn: number) {
    this.userService.GetRiaId(fdcn)
      .pipe(
        tap((id: number) => {
          this.data.updateRiaId(id);
        })
      ).subscribe();
  }

}
